import { combineReducers } from 'redux'
import * as actionTypes from './actionTypes'

export const sessionIdReducer = (state = null, action) => {
	switch (action.type) {
		case actionTypes.CREATE_SESSION_SUCCESS:
			return action.session_id

		default:
			return state
	}
}

export default combineReducers({
	sessionId: sessionIdReducer,
})

export const getSessionId = state => state.sessionId

// State Generators

export const createInitialState = sessionId => {
	return {
		sessionId,
	}
}
